import { render, staticRenderFns } from "./AttachLayout.vue?vue&type=template&id=a21c910e"
import script from "./AttachLayout.vue?vue&type=script&lang=js"
export * from "./AttachLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports